/**
 *
 * @param path sub path, for example "/technical-data/param1/value1/param2/value2"
 */
export function parsePath(path) {
    if (!path) {
        return undefined;
    }
    const match = path.split("/");
    if (match && match.length >= 1) {
        const name = match[1];
        if (!name) {
            return undefined;
        }
        if (path.length > name.length + 2) {
            const params = path
                .substring(name.length + 2)
                .split("/")
                .reduce((allParams, _val, idx, all) => {
                if (idx % 2 === 1 && idx > 0) {
                    allParams.append(decodeURIComponent(all[idx - 1]), decodeURIComponent(all[idx]));
                }
                return allParams;
            }, new URLSearchParams());
            return { name, params };
        }
        return { name, params: new URLSearchParams() };
    }
    return undefined;
}
//# sourceMappingURL=parse-path.js.map